// disease slice
import { createSlice } from "@reduxjs/toolkit";
import { firestore } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

const initialState = {
  diseases: [],
  isLoading: false,
  error: false,
};

export const diseaseSlice = createSlice({
  name: "disease",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET diseaseS
    getDiseasesSuccess(state, action) {
      state.isLoading = false;
      state.diseases = action.payload;
    },
    // create disease
    createDiseaseSuccess(state, action) {
      state.diseases.push(action.payload);
    },
    // update disease
    updateDiseaseSuccess(state, action) {
      state.diseases = state.diseases.map((disease) => {
        if (disease.id === action.payload.id) {
          return action.payload;
        }
        return disease;
      });
    },
    // delete souche
    deleteDiseaseSuccess(state, action) {
      const { id } = action.payload;
      state.diseases = state.diseases.filter((disease) => disease.id !== id);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  startLoading,
  hasError,
  getDiseasesSuccess,
  createDiseaseSuccess,
  updateDiseaseSuccess,
  deleteDiseaseSuccess,
} = diseaseSlice.actions;

export const createDisease = (data) => async (dispatch) => {
  const { name, description } = data;
  const docRef = collection(firestore, "disease");
  const newData = {
    name: name,
    description: description,
    timestamp: serverTimestamp(),
  };
  try {
    dispatch(startLoading());
    const addedDocRef = await addDoc(docRef, newData);
    const id = addedDocRef.id;
    // Update the document with the ID
    const docToUpdate = doc(firestore, "disease", id);
    await updateDoc(docToUpdate, { id });
    dispatch(createDiseaseSuccess({ ...newData, id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// update disease
export const updateDisease = (data) => async (dispatch) => {
  const { id, name, description } = data;
  const docRef = doc(firestore, "disease", id);
  try {
    dispatch(startLoading());
    await updateDoc(docRef, { name, description });
    dispatch(updateDiseaseSuccess({ id, name, description }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// delete disease
export const deleteDisease = (id) => async (dispatch) => {
  const docRef = doc(firestore, "disease", id);
  try {
    dispatch(startLoading());
    await deleteDoc(docRef);
    dispatch(deleteDiseaseSuccess({ id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};

// get diseases from firestore
export const getDiseases = () => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "disease"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getDiseasesSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};

export default diseaseSlice.reducer;
